var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('b-form-checkbox',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }